/**
 * AI Provider 설정 검증 유틸리티
 */

import type { AIProviderConfig } from '../types'

export interface ValidationResult {
  valid: boolean
  error?: string
}

/**
 * AI Provider 설정 검증
 */
export function validateProviderConfig(config: AIProviderConfig): ValidationResult {
  switch (config.provider) {
    case 'openai':
      if (!config.apiKey) {
        return { valid: false, error: 'OpenAI API key is required' }
      }
      break
      
    case 'anthropic':
      if (!config.apiKey) {
        return { valid: false, error: 'Anthropic API key is required' }
      }
      break
      
    case 'google':
      if (!config.apiKey) {
        return { valid: false, error: 'Google API key is required' }
      }
      break
      
    case 'upstage':
      if (!config.apiKey) {
        return { valid: false, error: 'Upstage API key is required' }
      }
      break
      
    case 'openrouter':
      if (!config.proxyUrl) {
        return { valid: false, error: 'Proxy URL is required for OpenRouter' }
      }
      break
      
    case 'mock':
      // Mock provider doesn't need validation
      break
      
    default:
      return { valid: false, error: `Unknown provider: ${config.provider}` }
  }
  
  return { valid: true }
}

/**
 * 디바이스 ID 생성/관리
 */
export function getDeviceId(): string {
  let deviceId = localStorage.getItem('deviceId')
  if (!deviceId) {
    deviceId = 'web-' + Math.random().toString(36).substring(7)
    localStorage.setItem('deviceId', deviceId)
  }
  return deviceId
}

/**
 * 인증 토큰 관리
 */
export class TokenManager {
  private static TOKEN_KEY = 'authToken'
  
  static get(): string | null {
    return localStorage.getItem(this.TOKEN_KEY)
  }
  
  static set(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token)
  }
  
  static remove(): void {
    localStorage.removeItem(this.TOKEN_KEY)
  }
  
  static exists(): boolean {
    return !!this.get()
  }
}